module.exports = __webpack_public_path__ + "img/ALPHAROMEO.7f9c30e.jpg";